window.initMap = function () {
    $(function () {
            var container = document.getElementById('map');
            if (container) {
                var map = new google.maps.Map(container, {
                    zoom: 12,
                    center: {
                        lat: 55.98609153380839,
                        lng: 92.8729248046875
                    }
                });

                var items = document.querySelectorAll('.js-map-point');
                if (items.length) {
                    var defaultCentred = true;
                    items.forEach(function (item) {
                        try {
                            var options = JSON.parse(item.dataset.json);

                            if (options && options.lat && options.lng) {
                                var marker = new google.maps.Marker({
                                    position: {
                                        lat: options.lat,
                                        lng: options.lng
                                    },
                                    map: map,
                                    icon: '/static/i/svg/marker.svg'
                                });
                                item.addEventListener('click', function () {
                                    map.panTo(marker.getPosition());
                                    map.setZoom(options.zoom);
                                });
                                if(defaultCentred) {
                                    defaultCentred = false;
                                    map.panTo(marker.getPosition());
                                    map.setZoom(options.zoom);
                                }
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    });
                }
            }
        }
    );
};
